!function() {
    "use strict";
    let t = t => {
        let e;
        return e = t ? "string" == typeof t ? new URL(t) : t : new URL(window.location.href),
        RegExp("/collections/", "i").test(e.pathname)
    }
    ;
    (d = S || (S = {})).CONTINUE = "continue",
    d.DENY = "deny",
    (u = y || (y = {})).EXACT = "exact",
    u.ABOVE = "above",
    u.BELOW = "below",
    u.EXACT_OR_ABOVE = "exact_or_above",
    u.EXACT_OR_BELOW = "exact_or_below",
    u.BETWEEN = "between",
    (h = f || (f = {})).INVENTORY_STATUS = "inventory_status",
    h.DISCOUNT_PRICE = "discount_price",
    h.PRICE_RANGE = "price_range",
    h.PRODUCT_TAGS = "product_tags",
    h.CREATION_DATE = "creation_date",
    (p = C || (C = {})).IN_STOCK = "in_stock",
    p.OUT_OF_STOCK = "out_of_stock",
    (v = _ || (_ = {})).DURATION = "duration",
    v.EXACT_DATE = "exact_date",
    v.BETWEEN_DATES = "between_dates",
    (g = m || (m = {})).PERCENT = "percent",
    g.FIXED = "fixed";
    let e = "variant"
      , i = [{
        selector: ".kaching-subscriptions__widget",
        source: {
            type: "attribute",
            name: "data-selling-plan-id"
        }
    }, {
        selector: "[data-bs-widget], .bs-subscription-widget",
        source: {
            type: "inputValue",
            selector: 'input.selected-selling-plan-id[name="selling_plan"]'
        }
    }];
    function n(t, e, i) {
        let n = t.getContext("variantSelected")
          , l = {
            ...n,
            price: e,
            compare_at_price: i
        };
        t.setContext("variantSelected", l)
    }
    function l(t, e, i) {
        return t.getContext("useProductCompareAtPrice") ? null == e ? void 0 : e.compare_at_price : i
    }
    function r(t, e, i) {
        var r;
        let a = null == e ? void 0 : null === (r = e.selling_plan_allocations) || void 0 === r ? void 0 : r.find(t => {
            var e;
            return (null === (e = t.selling_plan_id) || void 0 === e ? void 0 : e.toString()) === i
        }
        );
        a && n(t, a.price, l(t, e, a.compare_at_price))
    }
    function a(t, e) {
        var i;
        let r = null == e ? void 0 : null === (i = e.selling_plan_allocations) || void 0 === i ? void 0 : i[0];
        r && n(t, r.price, l(t, e, r.compare_at_price))
    }
    function o(t, e, i) {
        var l, o;
        let {sellingPlanId: c, radioType: s} = e.dataset;
        if (!s)
            return;
        let d = null != i ? i : t.getContext("variantSelected");
        null === (l = (o = {
            one_time_purchase: () => n(t, null == i ? void 0 : i.price, null == i ? void 0 : i.compare_at_price),
            selling_plan: () => c && r(t, d, c),
            selling_plan_group: () => a(t, d)
        })[s]) || void 0 === l || l.call(o)
    }
    let c = "gp:product-change-selling-plan-price";
    function s(t, e, i) {
        return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = i,
        t
    }
    var d, u, h, p, v, g, S, y, f, C, _, m, b = () => class extends GP.Component {
        connectedCallback() {
            this.initQuantity(),
            this.initInventoryQuantity(),
            this.addSubscribeContext(),
            this.onEventChangeVariant(),
            this.onEventChangeQuantity(),
            this.onEventBonySellingPlanChange(),
            this.onEventProductBundleChange(),
            this.onEventChangeSellingPlanPrice(),
            this.dispatchEvent(new CustomEvent("gp:product-init")),
            this.setState("isReady", !0);
            let t = this.querySelector("form");
            t && (this.variantSelectedCache = this.getContext("variantSelected"),
            t.addEventListener("change", t => {
                var e;
                e = this.variantSelectedCache,
                o(this, t.target, e)
            }
            )),
            this.thirdPartySubscriptionObserver = function(t, e, l) {
                let a = i.filter(t => "attribute" === t.source.type);
                if (0 === a.length)
                    return null;
                let o = Array.from(new Set(a.map(t => t.source.name)))
                  , c = (e, i) => {
                    var a;
                    let o = i.getAttribute(e.source.name);
                    if (o) {
                        r(t, null !== (a = l()) && void 0 !== a ? a : t.getContext("variantSelected"), o);
                        return
                    }
                    let c = l();
                    n(t, null == c ? void 0 : c.price, null == c ? void 0 : c.compare_at_price)
                }
                  , s = t => {
                    for (let e of a) {
                        let i = t.matches(e.selector) ? [t] : [];
                        for (let n of (i.push(...Array.from(t.querySelectorAll(e.selector))),
                        i))
                            n.getAttribute(e.source.name) && c(e, n)
                    }
                }
                  , d = t => a.some(e => t.matches(e.selector) || null !== t.querySelector(e.selector))
                  , u = null
                  , h = null
                  , p = () => {
                    h = null;
                    let t = u;
                    if (u = null,
                    t)
                        for (let e of t)
                            s(e)
                }
                  , v = () => {
                    null === h && (h = requestAnimationFrame(p))
                }
                  , g = new MutationObserver(t => {
                    for (let e of t) {
                        if ("attributes" === e.type && e.attributeName) {
                            let t = e.target
                              , i = a.find(i => i.source.name === e.attributeName && t.matches(i.selector));
                            i && c(i, t);
                            continue
                        }
                        if ("childList" === e.type)
                            for (let t of Array.from(e.addedNodes))
                                t.nodeType === Node.ELEMENT_NODE && d(t) && (u || (u = new Set),
                                u.add(t))
                    }
                    u && v()
                }
                );
                g.observe(e, {
                    subtree: !0,
                    childList: !0,
                    attributes: !0,
                    attributeFilter: o
                });
                let S = requestAnimationFrame( () => s(e));
                return {
                    disconnect() {
                        g.disconnect(),
                        cancelAnimationFrame(S),
                        null !== h && cancelAnimationFrame(h)
                    }
                }
            }(this, this, () => this.variantSelectedCache),
            this.shopifySubscriptionsTabWatcher = function(t, e, i) {
                var l;
                if (!e.querySelector(".shopify_subscriptions_app_block"))
                    return null;
                let r = null !== (l = e.querySelector("form")) && void 0 !== l ? l : e
                  , a = e => {
                    var l;
                    let r = null === (l = e.target) || void 0 === l ? void 0 : l.closest(".shopify_subscriptions_app_block input.tab_radio");
                    if (!r)
                        return;
                    let a = r.closest(".shopify_subscriptions_app_block");
                    if (a) {
                        if (r.id.startsWith("tab_otp_")) {
                            let e = i();
                            n(t, null == e ? void 0 : e.price, null == e ? void 0 : e.compare_at_price);
                            return
                        }
                        queueMicrotask( () => {
                            let e = a.querySelector('input[type="radio"][data-radio-type]:checked');
                            e && o(t, e, i())
                        }
                        )
                    }
                }
                ;
                return r.addEventListener("change", a),
                {
                    disconnect() {
                        r.removeEventListener("change", a)
                    }
                }
            }(this, this, () => this.variantSelectedCache)
        }
        disconnectedCallback() {
            var t, e;
            null === (t = this.thirdPartySubscriptionObserver) || void 0 === t || t.disconnect(),
            this.thirdPartySubscriptionObserver = null,
            null === (e = this.shopifySubscriptionsTabWatcher) || void 0 === e || e.disconnect(),
            this.shopifySubscriptionsTabWatcher = null,
            window.removeEventListener(c, this.handleSellingPlanPriceChange)
        }
        handleSetProductTitleLink() {
            this.setProductTitleSelectors(),
            this.handleProductTitleLinkWrapper(),
            this.subscribeToVariantChanges()
        }
        initQuantity() {
            this.quantity && !this.quantity.value && (this.quantity.value = "1")
        }
        initInventoryQuantity() {
            let t = this.getContext("variantSelected")
              , e = this.getContext("inventoryQuantity")
              , i = this.getContext("inventory_policy")
              , n = i === S.CONTINUE || !(null == t ? void 0 : t.inventoryQuantity) && e;
            t && n && (t.inventoryQuantity = e,
            t.inventory_policy = i,
            this.setContext("variantSelected", t))
        }
        addSubscribeContext() {
            this.subscribeContext( (t, e) => {
                var n, l, o, c, s, d, u, h, p, v, g;
                let S = (null === (n = t.variantSelected) || void 0 === n ? void 0 : n.price) !== (null === (l = e.variantSelected) || void 0 === l ? void 0 : l.price) || (null === (o = t.variantSelected) || void 0 === o ? void 0 : o.compare_at_price) !== (null === (c = e.variantSelected) || void 0 === c ? void 0 : c.compare_at_price);
                (null === (s = t.variantSelected) || void 0 === s ? void 0 : s.id) !== (null === (d = e.variantSelected) || void 0 === d ? void 0 : d.id) ? (this.variantSelectedID && (null === (u = t.variantSelected) || void 0 === u ? void 0 : u.id) && (this.variantSelectedID.value = t.variantSelected.id.toString()),
                this.quantity && (this.quantity.value = null !== (p = null === (h = t.quantity) || void 0 === h ? void 0 : h.toString()) && void 0 !== p ? p : "1"),
                this.variantSelectedCache = t.variantSelected,
                queueMicrotask( () => {
                    !function(t, e) {
                        let n = e.querySelector("form");
                        if (!n)
                            return;
                        let l = t.getContext("variantSelected")
                          , o = null == l ? void 0 : l.id;
                        if (!o)
                            return;
                        let c = n.querySelector(`input[data-radio-type]:checked[name$="_${o}"]`);
                        if (!c) {
                            let n = function(t) {
                                for (let e of i) {
                                    let i = function(t, e) {
                                        var i, n;
                                        let l = t.matches(e.selector) ? t : t.querySelector(e.selector);
                                        if (!l)
                                            return null;
                                        if ("attribute" === e.source.type)
                                            return l.getAttribute(e.source.name) || null;
                                        let r = t.matches("form") ? t : null !== (n = t.querySelector("form")) && void 0 !== n ? n : t;
                                        return (null === (i = r.querySelector(e.source.selector)) || void 0 === i ? void 0 : i.value) || null
                                    }(t, e);
                                    if (i)
                                        return i
                                }
                                return null
                            }(e);
                            n && r(t, l, n);
                            return
                        }
                        let {radioType: s, sellingPlanId: d} = c.dataset;
                        if ("selling_plan" === s && d) {
                            r(t, l, d);
                            return
                        }
                        "selling_plan_group" === s && a(t, l)
                    }(this, this)
                }
                )) : !this.isApplyingSyncedSellingPlanPrice && t.variantSelected && S && this.broadcastSellingPlanPriceChange(t.variantSelected),
                t.quantity != e.quantity && this.quantity && (this.quantity.value = null !== (g = null === (v = t.quantity) || void 0 === v ? void 0 : v.toString()) && void 0 !== g ? g : "1")
            }
            )
        }
        broadcastSellingPlanPriceChange(t) {
            var e, i;
            let n = this.getContext();
            (null == n ? void 0 : n.isSyncProduct) === "true" && (null === (e = t.selling_plan_allocations) || void 0 === e ? void 0 : e.length) && window.dispatchEvent(new CustomEvent(c,{
                bubbles: !0,
                cancelable: !0,
                composed: !0,
                detail: {
                    productId: null !== (i = null == n ? void 0 : n.productId) && void 0 !== i ? i : "",
                    productElementUid: this.dataset.uid,
                    price: t.price,
                    compareAtPrice: t.compare_at_price
                }
            }))
        }
        onEventChangeSellingPlanPrice() {
            window.addEventListener(c, this.handleSellingPlanPriceChange)
        }
        onEventChangeVariant() {
            window.addEventListener("gp:product-change-variant", t => {
                if (t.detail) {
                    let l = t.detail.productId
                      , r = t.detail.variantSelected
                      , a = t.detail.productElementUid
                      , o = t.detail.fromIsSyncProduct
                      , c = this.getContext()
                      , s = c.productId
                      , d = c.isSyncProduct
                      , u = this.dataset.uid;
                    if (l == s && (u && u === a || "true" == o && "true" == d)) {
                        var e, i, n;
                        this.setContext("variantSelected", r);
                        let t = null == r ? void 0 : r.options
                          , l = {};
                        for (let e of t) {
                            let t = this.querySelectorAll(`select[name="${e.name.replace(/['"\\]/g, "\\$&")}"]`);
                            for (let i of Array.from(t))
                                i.value = e.value;
                            l[`${e.name}`] = e.value
                        }
                        let a = this.querySelectorAll("gp-product-variants");
                        for (let t of Array.from(a))
                            t.setState && (t.setState("currentSelected", l),
                            null === (e = t.setStyleOptionValue) || void 0 === e || e.call(t, l, {
                                shopifyProductOptionValues: null == r ? void 0 : r.shopifyProductOptionValues
                            }),
                            null === (i = t.changeVariantLabel) || void 0 === i || i.call(t, l));
                        let o = this.querySelectorAll("#p-variant-group-dropdown");
                        for (let t of Array.from(o))
                            t.value = null == r ? void 0 : null === (n = r.id) || void 0 === n ? void 0 : n.toString()
                    }
                }
            }
            )
        }
        onEventChangeQuantity() {
            window.addEventListener("gp:product-change-quantity", t => {
                if (t.detail) {
                    let e = t.detail.productId
                      , i = t.detail.quantity
                      , n = this.getContext()
                      , l = n.productId
                      , r = n.isSyncProduct
                      , a = n.quantity;
                    e == l && a != i && "true" == r && (this.setContext("isQuantityChange", !0),
                    this.setContext("quantity", i))
                }
            }
            )
        }
        onEventBonySellingPlanChange() {
            window.addEventListener("bs:selected-selling-plan-changed", t => {
                var e, i, l, a;
                let {productId: o, sellingPlanId: c} = null !== (l = t.detail) && void 0 !== l ? l : {}
                  , s = this.getContext()
                  , d = s.productId;
                if (o != d)
                    return;
                let u = this.getContext("variantSelected");
                if (u) {
                    if (c) {
                        r(this, null !== (a = this.variantSelectedCache) && void 0 !== a ? a : u, String(c));
                        return
                    }
                    n(this, null === (e = this.variantSelectedCache) || void 0 === e ? void 0 : e.price, null === (i = this.variantSelectedCache) || void 0 === i ? void 0 : i.compare_at_price)
                }
            }
            )
        }
        onEventProductBundleChange() {
            window.addEventListener("gp:product-bundle-change", t => {
                let {detail: e} = t;
                if (!e)
                    return;
                let {productId: i, productCustomPrice: n, useProductCompareAtPrice: l, hasBundleDiscountActive: r, quantity: a} = e
                  , {productId: o, productCustomPrice: c, isSyncProduct: s} = this.getContext();
                i === o && "true" === s && this.notBundleEqual(n, c) && (this.setContext("quantity", a),
                this.setContext("productCustomPrice", n),
                this.setContext("useProductCompareAtPrice", l),
                this.setContext("hasBundleDiscountActive", r))
            }
            )
        }
        notBundleEqual(t, e) {
            return JSON.stringify(t) !== JSON.stringify(e)
        }
        constructor() {
            super(),
            s(this, "quantity", null),
            s(this, "variantSelectedID", null),
            s(this, "variantSelectedCache", void 0),
            s(this, "thirdPartySubscriptionObserver", null),
            s(this, "shopifySubscriptionsTabWatcher", null),
            s(this, "isApplyingSyncedSellingPlanPrice", !1),
            s(this, "productTitleLinkWrapper", void 0),
            s(this, "handleSellingPlanPriceChange", t => {
                let {detail: e} = t;
                if (!e)
                    return;
                let {productId: i, productElementUid: l, price: r, compareAtPrice: a} = e;
                if (l && l === this.dataset.uid)
                    return;
                let o = this.getContext();
                i == (null == o ? void 0 : o.productId) && (null == o ? void 0 : o.isSyncProduct) == "true" && (this.isApplyingSyncedSellingPlanPrice = !0,
                n(this, r, a),
                this.isApplyingSyncedSellingPlanPrice = !1)
            }
            ),
            s(this, "setProductTitleSelectors", () => {
                var t;
                this.productTitleLinkWrapper = null === (t = this.getElementsByClassName("gp-product-title-link-wrapper")) || void 0 === t ? void 0 : t[0]
            }
            ),
            s(this, "subscribeToVariantChanges", () => {
                this.subscribeContext( (t, i) => {
                    var n, l, r;
                    if ((null === (n = t.variantSelected) || void 0 === n ? void 0 : n.id) === (null === (l = i.variantSelected) || void 0 === l ? void 0 : l.id) || !this.productTitleLinkWrapper)
                        return;
                    let a = new URL(this.productTitleLinkWrapper.href,window.location.origin);
                    (null === (r = t.variantSelected) || void 0 === r ? void 0 : r.id) ? a.searchParams.set(e, t.variantSelected.id.toString()) : a.searchParams.delete(e),
                    this.productTitleLinkWrapper.href = a.toString()
                }
                )
            }
            ),
            s(this, "setProductInCollectionLink", () => {
                var t;
                if (!this.productTitleLinkWrapper)
                    return;
                let {productHandle: e, collectionHandle: i, collectionUrl: n, pageContext: l} = this.getState();
                if (!i || !n || !e)
                    return;
                let r = e ? `/products/${e}` : ""
                  , a = null != n ? n : `/collections/${i}`
                  , o = null === (t = null == l ? void 0 : l.hasCollectionHandle) || void 0 === t || t;
                this.productTitleLinkWrapper.href = `${o ? a : ""}${r}`
            }
            ),
            s(this, "setProductLink", () => {
                if (!this.productTitleLinkWrapper)
                    return;
                let {productUrl: t, productHandle: e} = this.getState();
                if (!t || !e)
                    return;
                let i = e ? `/products/${e}` : "#";
                this.productTitleLinkWrapper.href = null != t ? t : i
            }
            ),
            s(this, "handleProductTitleLinkWrapper", () => {
                t() ? this.setProductInCollectionLink() : this.setProductLink()
            }
            ),
            this.quantity = this.querySelector('input[name="quantity"]'),
            this.variantSelectedID = this.querySelector('input[name="id"]'),
            this.handleSetProductTitleLink(),
            this.handleSellingPlanPriceChange = this.handleSellingPlanPriceChange.bind(this)
        }
    }
    ;
    let P = () => {
        window.removeEventListener("gp-global-loaded", P),
        customElements.get("gp-product") || customElements.define("gp-product", b())
    }
    ;
    "completed" === window.gpReadyState ? P() : window.addEventListener("gp-global-loaded", P)
}();
